import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPagedCollectionResult, mapCollection } from '@mango/core';
import { Merk } from 'src/app/core/dto/merk';
import { Soort } from 'src/app/core/dto/soort';
import { map } from 'rxjs/operators';
import { Artikelgroep } from 'src/app/core/dto/artikelgroep';

@Injectable()
export class PrijscorrectieArtikelService {

    constructor(private http: HttpClient) {
 
    }

  Prijscorrectie(alles: boolean, artikelGroepID: Artikelgroep, percentage: number) {

        var artikelgroep = -1;

        if (artikelGroepID != null) {
            artikelgroep = artikelGroepID.id;
        }
       
        let query: string = `api/dto/artikel/prijscorrectieArtikel?alles=${alles}&artikelGroepId=${artikelgroep}&percentage=${percentage}`
        
        return this.http.post(query, null).pipe(map(x => x as PrijscorrectieArtikelResponse));
    }
    
}

export class PrijscorrectieArtikelResponse {
    successful: boolean;
    message: string;
}
